// Logger API
import {
    RequestConfigFunction, SelectorConfig,
} from 'app/types/request.types'
import {
    LoggerPosition, LoggerType,
} from 'app/enums/label.enums'

type LoggerParams = {
    loggerNumber: string,
    loggerType: LoggerType,
    allowedSensorPositions: LoggerPosition[]
}

type LoggerRequests = {
    domainName: string,
    get: RequestConfigFunction<{ id: number }>,
    getByLoggerNumber: RequestConfigFunction<{ loggerNumber: string }>,
    create: RequestConfigFunction,
    update: RequestConfigFunction<{ serialNumber: string }>,
    modifications: RequestConfigFunction<{ id: number }>,
    selector: SelectorConfig<LoggerParams[], LoggerParams>,
    removeCalibrationDocument: RequestConfigFunction<{ loggerId: number, documentId: number }>,
    addDocument: RequestConfigFunction<{ loggerId: number, data: Record<string, any> }>,
    getLoggerDocuments: RequestConfigFunction<{ loggerId: number }>,
    filterRequestAll: RequestConfigFunction,
    batchUpdateLoggerStatus: RequestConfigFunction<{ loggerId: number, data: Record<string, any> }>,
    batchUpdateRentingCompany:
        RequestConfigFunction<{ loggerId: number, data: Record<string, any> }>,
    batchUpdateDestinationLocation:
        RequestConfigFunction<{ loggerId: number, data: Record<string, any> }>,
}

const loggerRequests: LoggerRequests = {
    domainName: 'Logger',
    selector: {
        url: 'logger/filter-request/selector',
        convertion: (items) => {
            return items.map(({
                loggerNumber, loggerType, allowedSensorPositions,
            }) => {
                return {
                    label: loggerNumber,
                    loggerNumber,
                    loggerType,
                    allowedSensorPositions,
                    value: loggerNumber,
                }
            })
        },
    },
    get: ({
        id,
    }) => {
        return {
            url: `logger/${id}`,
            method: 'GET',
        }
    },
    getByLoggerNumber: ({
        loggerNumber,
    }) => {
        return {
            url: `logger/loggernumber/${loggerNumber}`,
            method: 'GET',
        }
    },
    create: () => {
        return {
            url: 'logger',
            method: 'POST',
        }
    },
    update: ({
        serialNumber,
    }) => {
        return {
            url: `logger/${serialNumber}/data`,
            method: 'PATCH',
        }
    },

    modifications: ({
        id,
    }) => {
        return {
            url: `logger/${id}/modifications`,
            method: 'GET',
        }
    },
    removeCalibrationDocument: ({
        loggerId, documentId,
    }) => {
        return {
            url: `logger/${loggerId}/calibration/${documentId}/removal`,
            method: 'PATCH',
        }
    },
    addDocument: ({
        loggerId, data,
    }) => {
        return {
            url: `logger/${loggerId}/calibration`,
            data,
            method: 'POST',
        }
    },
    getLoggerDocuments: ({
        loggerId,
    }: {
        loggerId: number,
    }) => {
        return {
            url: `logger/${loggerId}/calibration/filter-request/all`,
            method: 'POST',
        }
    },
    filterRequestAll: () => {
        return {
            url: 'logger/filter-request/all',
            method: 'POST',
        }
    },
    batchUpdateLoggerStatus: ({
        loggerId, data,
    }) => {
        return {
            url: `logger/${loggerId}/batch/loggerstatus`,
            method: 'PATCH',
            data,
        }
    },
    batchUpdateRentingCompany: ({
        loggerId, data,
    }) => {
        return {
            url: `logger/${loggerId}/batch/rentingcompany`,
            method: 'PATCH',
            data,
        }
    },
    batchUpdateDestinationLocation: ({
        loggerId, data,
    }) => {
        return {
            url: `logger/${loggerId}/batch/destinationlocation`,
            method: 'PATCH',
            data,
        }
    },
}

export default loggerRequests
